module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-brands-400.eot?a38ca9f0501109549cb659c1fe9ade65";